import get from "lodash/get";
import React, { FC, memo, useEffect } from "react";
import { Button } from "@pd/pd-ui-kit";

import PanelWrapper from "~/components/PanelWrapper";
import { getIndicatorValue } from "~/libs/getData";
import { newFormat } from "~/pages/Q/formater";
import { useGetWorkSpaceDealerQQuery } from "~/schemas/generated/graphql";
import { useCurrentDealerId } from "~/shared/hooks/useCurrentDealerId";

import s from "./BlockQ.less";

interface IProps {
  onClick?: () => void;
  date?;
  oldVisual?: boolean;
}

const BlockQ: FC<IProps> = ({ onClick, date = undefined, oldVisual }) => {
  const currentDealerId = useCurrentDealerId();
  const { data, loading, refetch } = useGetWorkSpaceDealerQQuery({
    variables: date
      ? {
          DealerId: currentDealerId,
          date: date && newFormat(date),
        }
      : {
          DealerId: currentDealerId,
        },
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    refetch();
  }, [date, currentDealerId]);

  const qIndicatorGroupValue = getIndicatorValue(
    get(data, "WorkSpaceGetter.getQ.IndicatorGroup", {}),
  );
  const qIndicatorValue = getIndicatorValue(
    get(data, "WorkSpaceGetter.getQ.Indicator", {}),
  );

  const qColor =
    (qIndicatorGroupValue.trim() === "I" && "#B2D363") ||
    (qIndicatorGroupValue.trim() === "II" && "#FFDE5A") ||
    (qIndicatorGroupValue.trim() === "III" && "#FA9863") ||
    (qIndicatorGroupValue.trim() === "IV" && "#FF747C") ||
    undefined;

  if (oldVisual) {
    return (
      <PanelWrapper
        width={80}
        backgroundColor={qColor}
        clickable
        customClassName={s.text_center}
        loading={loading}
      >
        <div className={s.q_panel} onClick={onClick}>
          Q
          <strong>
            {qIndicatorGroupValue}/{qIndicatorValue}
          </strong>
        </div>
      </PanelWrapper>
    );
  }

  return (
    <Button
      color={"secondary"}
      size={"middle"}
      fontSize="12"
      radius={30}
      style={{
        backgroundColor: qColor,
      }}
      onClick={onClick}
    >
      Q
      <strong>
        {qIndicatorGroupValue}/{qIndicatorValue}
      </strong>
    </Button>
  );
};

export default memo(BlockQ);
